import styled from "@emotion/styled";

import { fontMerriweather, fontRobotoCondensed, theme, transientOptions } from "shared/lib/styles";

import { StyledFigcaption } from "scmp-app/components/content/content-cover-image/styles";
import { SponsorHeadline } from "scmp-app/components/content/content-headline/styles";
import { StyledTopicLink } from "scmp-app/components/content/content-topic-link/styles";
import { EntityLink } from "scmp-app/components/entity-link";
import { StyledLi } from "scmp-app/components/schema-render/content/styles";
import {
  playIconBackgroundHoverStyles,
  StyledPlayIcon,
} from "scmp-app/components/video/video-play-icon/styles";

export const Container = styled.div`
  display: grid;
  grid-template:
    "header" min-content
    "headline" min-content
    "footer" min-content
    "cover-image" auto
    / 1fr;
`;

export const StyledEntityLink = styled(EntityLink)`
  color: #000000;
`;

export const StyledHeadlineEntityLink = styled(StyledEntityLink)``;

export const TopicLabel = styled.div`
  ${StyledTopicLink} {
    color: #4585ff;
    font-weight: 700;
    font-size: 13px;
    font-family: ${fontRobotoCondensed};
    text-transform: uppercase;
  }
`;

export const Headline = styled.div`
  display: flex;
  flex-flow: row nowrap;
  gap: 12px;
  align-items: flex-start;

  margin-block-end: 12px;

  font-weight: 700;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 25.2px;

  ${SponsorHeadline} {
    font-weight: 700;
    line-height: 22.4px;
  }
`;

export const Summary = styled.div`
  margin-block-end: 12px;

  color: #6f6f6f;
  font-size: 14px;
  line-height: 18.2px;

  &:empty {
    margin: 0;
  }
`;

export const SubHeadline = styled.div`
  color: #6f6f6f;
  font-size: 14px;
  line-height: 18.2px;

  ${StyledLi} {
    margin-block-end: 12px;
  }

  &:empty {
    margin: 0;
  }
`;

export const ActionBar = styled.div`
  grid-area: footer;
  time {
    color: #999999;
    font-size: 12px;
  }
`;

type StyledCoverEntityLinkProps = {
  $isSponsorArticle?: boolean;
};
export const StyledCoverEntityLink = styled(EntityLink, {
  ...transientOptions,
})<StyledCoverEntityLinkProps>`
  grid-area: cover-image;

  position: relative;

  display: ${props => (props.$isSponsorArticle ? "block" : "none")};

  margin-block-start: 12px;

  &:hover ${StyledPlayIcon} {
    ${playIconBackgroundHoverStyles}
  }

  ${theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const CoverImage = styled.div`
  inline-size: 120px;
  block-size: 80px;

  ${StyledFigcaption} {
    ${theme.breakpoints.up("tablet")} {
      line-height: 14px;
    }
  }
`;

export const SponsorTagContainer = styled.div`
  grid-area: footer;

  max-inline-size: 240px;
`;

export const LiveTagContainer = styled.div``;

export const SectionContainer = styled.div``;

export const Header = styled.div`
  grid-area: header;

  display: flex;
  align-items: center;

  :empty {
    margin-block-end: 0;
  }

  ${TopicLabel} {
    margin-block-end: 8px;
  }
  ${LiveTagContainer} {
    margin-block-end: 8px;
  }
  ${SectionContainer} {
    margin-block-end: 8px;
  }
`;
